import { createSlice } from "@reduxjs/toolkit";
import { rejectClaim } from "../../reducer/claimsReject/claimsRejectReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const rejectClaimSlice = createSlice({
  name: "rejectClaim",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rejectClaim.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(rejectClaim.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(rejectClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default rejectClaimSlice.reducer;
